import axios, { AxiosError } from "axios";
import api from "./Api";
import {
  formatAppointmentDateTime,
  formatAppointmentInfo,
  to12Hour,
} from "../utils/dateUtils";
const PICKLIST_URL = process.env.REACT_APP_PICKLIST_URL || "";
//const DR_SCHEDULE_URL = process.env.REACT_APP_SCHEDULE_URL || "";
const DR_SCHEDULE_URL = process.env.REACT_APP_CASE_URL || "";
const dr_schedule = api(DR_SCHEDULE_URL);
const DR_SCHEDULE_URL1 = api(PICKLIST_URL);
const dr_schedule1 = api(PICKLIST_URL);
export const FetchQMEDoctorScheduleList = async (
  qmeDoctorContactId: any,
  year: number,
  month: string,
  medicareProviderIds: string
): Promise<any> => {
  try {
    const response = await dr_schedule.post(
      "/api/appointment/calendar-viewlist",
      {
        qmeDoctorContactId,
        year,
        month,
        medicareProviderIds,
      }
    );

    if (!response.data?.result || !Array.isArray(response.data.result)) {
      // console.error("❌ Unexpected API response format:", response.data);
      throw new Error("Invalid API response: Expected an array in 'result'.");
    }

    // Process response data
    const updatedResult = response.data.result.map((schedule: any) => ({
      doctorId: schedule.qmeDoctorContactId,
      calendarOptionType: schedule.calendarOptionType,
      dateOfAppointment: schedule.dateOfAppointmentInfo,
      startTime: schedule.startTime,
      endTime: schedule.endTime,
      medicareId: schedule.medicareId,
      providerName: formatAppointmentInfo(schedule.providerName),
      scheduleId: schedule.scheduledAppId,
      patientName: schedule.patientName,
      locationAddress: schedule.locationAddress,
      doctorName: schedule.doctorName,
      location: schedule.location,
      examType: schedule.examType,
      subjectQMEScheduleId: schedule.subjectQMEScheduleId,
    }));
    //console.error("❌ Unexpected API response format:", updatedResult);
    return { isSuccess: response.data.isSuccess, result: updatedResult };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to fetch doctor schedules. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
export const FetchQMEDoctorForToolTip = async (
  qmeDoctorContactId: any,
  year: number,
  month: string,
  day: string,
  medicareProviderIds: string
): Promise<any> => {
  try {
    const response = await dr_schedule.post(
      "/api/appointment/calendar-viewlist",
      {
        qmeDoctorContactId,
        year,
        month,
        day,
        medicareProviderIds,
      }
    );

    if (!response.data?.result || !Array.isArray(response.data.result)) {
      // console.error("❌ Unexpected API response format:", response.data);
      throw new Error("Invalid API response: Expected an array in 'result'.");
    }

    // Process response data
    const updatedResult = response.data.result.map((schedule: any) => ({
      doctorId: schedule.qmeDoctorContactId,
      calendarOptionType: schedule.calendarOptionType,
      dateOfAppointment: schedule.dateOfAppointmentInfo,
      startTime: to12Hour(schedule.startTime),
      endTime: to12Hour(schedule.endTime),
      medicareId: schedule.medicareId,
      providerName: formatAppointmentInfo(schedule.providerName),
      scheduleId: schedule.scheduledAppId,
    }));
    //console.error("❌ Unexpected API response format:", updatedResult);
    return { isSuccess: response.data.isSuccess, result: updatedResult };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to fetch doctor schedules. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
export const FetchDoctorScheduleForCalendarCount = async (
  qmeDoctorContactId: any,
  year: any,
  month: string,
  medicareProviderIds: string
): Promise<any> => {
  try {
    const response = await dr_schedule.post(
      "/api/appointment/qmedoctor/totalappointments/count",
      {
        qmeDoctorContactId,
        year,
        month,
        medicareProviderIds,
      }
    );

    // Validate response structure
    if (!response.data?.result || !Array.isArray(response.data.result)) {
      console.error("❌ Unexpected API response format:", response.data);
      throw new Error("Invalid API response: Expected an array in 'result'.");
    }

    // Process response data for the calendar
    const calendarData = response.data.result.map((schedule: any) => ({
      appointmentDate: schedule.appointmentDate,
      totalAppointments: schedule.totalAppointments,
    }));

    return { isSuccess: response.data.isSuccess, result: calendarData };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to fetch calendar data. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const FetchMedicareList = async (
  stakeholderContactId: any
): Promise<any> => {
  try {
    const response = await dr_schedule1.get(
      `/api/stakeholder/contact/medicarelist?contactUserId=${stakeholderContactId}`
    );

    // Debugging API Response

    // Validate API response structure
    if (!response.data || !Array.isArray(response.data.result)) {
      // console.error("❌ Unexpected API response format:", response.data);
      throw new Error("Invalid API response: Expected an array in 'result'.");
    }

    // Transform data for usage
    const list = response.data.result.map((item: any) => ({
      ...item,
      value: item.contactMedicareListId,
      label: item.providerName,
    }));

    return list;
  } catch (error) {
    console.error("Error fetching the Medicare list:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

export const FetchDoctorScheduleDetails = async (
  scheduleId: any
): Promise<any> => {
  try {
    const response = await dr_schedule.get(
      `/api/doctorschedule/details?scheduleId=${scheduleId}`
    );

    // if (!response.data?.result) {
    //   //  / console.error("❌ Unexpected API response format:", response.data);
    //   throw new Error("Invalid API response: Expected 'result' object.");
    // }
    const result = response.data?.result;
    if (!result || typeof result !== "object") {
      throw new Error("Invalid API response: Expected 'result' object.");
    }
    // Extract necessary details
    const calendarData = response.data.result.map((appointment: any) => ({
      appointmentDate: appointment.appointmentDate,
      totalAppointments: appointment.totalAppointments,
      responseCode: appointment.responseCode,
      responseMessage: appointment.responseMessage,
    }));
    return { isSuccess: response.data.isSuccess, result: calendarData };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to fetch doctor schedule details. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
export const FetchStakeholderContactByUserId = async (
  userId: any
): Promise<any> => {
  try {
    const response = await dr_schedule1.get(
      `/api/stakeholder/contactid/byuserid?userId=${userId}`
    );

    //console.log("✅ Stakeholder Contact API Response:", response.data);

    if (!response.data?.result) {
      // console.error("❌ Unexpected API response format:", response.data);
      throw new Error("Invalid API response: Expected 'result' object.");
    }

    return { isSuccess: response.data.isSuccess, result: response.data.result };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to fetch stakeholder contact details. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
export const FetchScheduleList = async (payload: {
  qmeDoctorContactId: any;
  year: any;
  month: any;
  medicareProviderIds: any;
}): Promise<any> => {
  try {
    const response = await dr_schedule.post(
      "/api/doctorschedule/list",
      payload
    );

    if (!response.data?.result || !Array.isArray(response.data.result)) {
      throw new Error("Invalid API response: Expected an array in 'result'.");
    }

    const parsedResult = response.data.result.map((item: any) => ({
      scheduleId: item.scheduleId,
      qmeDoctorContactId: item.qmeDoctorContactId,
      qmeDoctorFullName: item.qmeDoctorFullName,
      scheduleType: item.scheduleType,
      scheduleMode: item.scheduleMode,
      selectedMonths: item.selectedMonths,
      selectedWeekdays: item.selectedWeekdays,
      startDate: item.startDate,
      endDate: item.endDate,
      startTime: item.startTime,
      endTime: item.endTime,
      medicareProviderId: item.medicareProviderId,
      medicareProviderName: item.medicareProviderName,
      nonAvailabilityReason: item.nonAvailabilityReason,
      createdDate: item.createdDate,
      createdBy: item.createdBy,
      createdByName: item.createdByName,
      modifiedDate: item.modifiedDate,
      modifiedBy: item.modifiedBy,
      modifiedByName: item.modifiedByName,
      isReadOnly: item.isReadOnly,
    }));

    return { isSuccess: response.data.isSuccess, result: parsedResult };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to fetch doctor schedule list. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
export const CancelDoctorScheduleByDays = async (
  scheduleDayIds: string,
  cancellationReason: string
): Promise<any> => {
  try {
    const response = await dr_schedule.post(
      "/api/doctorschedule/delete/by-scheduledays",
      {
        scheduleDayIds,
        cancellationReason,
      }
    );

    if (!response.data?.result) {
      throw new Error("Invalid API response: Expected 'result' object.");
    }

    return {
      isSuccess: response.data.isSuccess,
      result: response.data.result,
      message: response.data.result.message || "Cancellation successful",
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to cancel the doctor schedule. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
export const CancelDoctorScheduleScheduleId = async (
  scheduleId: string,
  cancellationReason: string
): Promise<any> => {
  try {
    const response = await dr_schedule.post(
      "/api/doctorschedule/delete/by-scheduleid",
      {
        scheduleId,
        cancellationReason,
      }
    );

    if (!response.data?.result) {
      throw new Error("Invalid API response: Expected 'result' object.");
    }

    return {
      isSuccess: response.data.isSuccess,
      result: response.data.result,
      message: response.data.result.message || "Cancellation successful",
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to cancel the doctor schedule. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
export const ValidateAppointmentByScheduleId = async (
  scheduleId: number
): Promise<any> => {
  try {
    const response = await dr_schedule.get(
      `/api/doctorschedule/validate-appointment/by-scheduleid?scheduleId=${scheduleId}`
    );

    const updatedResult = response.data?.result.map((data: any) => ({
      ...data,
      dateOfAppointment: formatAppointmentDateTime(data.dateOfAppointment),
    }));

    return updatedResult;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to validate the appointment. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
export const ValidateAppointmentBySchedulByDay = async (
  scheduleDayIds: String
): Promise<any> => {
  try {
    const response = await dr_schedule.get(
      `/api/doctorschedule/validate-appointment/by-scheduledays?scheduleDayIds=${scheduleDayIds}`
    );

    if (!response.data?.result) {
      throw new Error("Invalid API response: Expected 'result' object.");
    }

    return {
      isSuccess: response.data.isSuccess,
      result: response.data.result,
      message: response.data.message || "Validation successful",
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to validate the appointment. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const fetchScheduleDayslist = async (
  scheduleId: number
): Promise<any> => {
  try {
    const response = await dr_schedule.get(
      `/api/doctorschedule/list/by-scheduleid?scheduleId=${scheduleId}`
    );

    if (!response.data?.result) {
      throw new Error("Invalid API response: Expected 'result' object.");
    }

    return {
      isSuccess: response.data.isSuccess,
      result: response.data.result,
      message: response.data.message || "Validation successful",
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to validate the appointment. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const ValidateAppointmentByDateandMonth = async (
  scheduleData: any
): Promise<any> => {
  try {
    const response = await dr_schedule.post(
      `/api/doctorschedule/qme/doctor/appointments`,
      scheduleData
    );

    const updatedResult = response.data?.result.map((data: any) => ({
      ...data,
      dateOfAppointment: formatAppointmentDateTime(data.dateOfAppointment),
    }));

    return updatedResult;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to validate the appointment. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
